import { render, staticRenderFns } from "./MiniKaskoCarForm.vue?vue&type=template&id=04788c40&scoped=true&"
import script from "./MiniKaskoCarForm.vue?vue&type=script&lang=js&"
export * from "./MiniKaskoCarForm.vue?vue&type=script&lang=js&"
import style0 from "./MiniKaskoCarForm.vue?vue&type=style&index=0&id=04788c40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04788c40",
  null
  
)

export default component.exports